import { render, staticRenderFns } from "./SortItem.vue?vue&type=template&id=9befba8e&scoped=true&"
import script from "./SortItem.vue?vue&type=script&lang=js&"
export * from "./SortItem.vue?vue&type=script&lang=js&"
import style0 from "./SortItem.vue?vue&type=style&index=0&id=9befba8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9befba8e",
  null
  
)

export default component.exports